import './Blogs.css';
import './BlogsLoader.css';
import { useEffect, useState, useRef } from 'react';
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Alert from 'react-bootstrap/Alert';
import { ReactMarkdownWithPlugins } from "./../shared/ReactMarkdownWithPlugins.js";
import { ContentEdit } from "./../shared/ContentEdit.js";
import { Preview } from "./../shared/Preview.js";
import { getLastUpdatedByRelative, getLastUpdatedByAbsolute } from "../shared/ContentUtility.js";
import { getUserInfo } from "./../shared/UserUtility.js";
import Badge from 'react-bootstrap/Badge';
import Placeholder from 'react-bootstrap/Placeholder';

function BlogDetails() {
    let params = useParams()
    let slug = params.slug;

    const navigate = useNavigate();

    // this block of code handles screen size width to reset picture size
    const [currWidth, setCurrWidth] = useState(window.innerWidth);
    function handleResize() {
        setCurrWidth(window.innerWidth);
    }
    window.addEventListener('resize', handleResize);
    ///////////////////////////////////////////////

    const [userId, setUserId] = useState(null);
    getUserInfo().then(userInfo => {
        if (userInfo) {
            setUserId(userInfo.userId);
        }
    });

    // this block of code handles two: set blog & set author
    const [theBlogAuthor, setTheBlogAuthor] = useState(null);
    const [theBlog, setTheBlog] = useState(null);
    const [theBlogLastUpdated, setTheBlogLastUpdated] = useState(null);
    const [theBlogLastUpdatedSwitch, setTheBlogLastUpdatedSwitch] = useState(true);
    const location = useLocation();
    useEffect(() => {
        let previousState = location.state;
        if (previousState) {
            let data = previousState.data;
            if (data && data.id) {
                let sessionBlog = sessionStorage.getItem(data.id);
                let jsonBlog = JSON.parse(sessionBlog);
                if (jsonBlog && jsonBlog._ts > data._ts) {
                    setTheBlog(jsonBlog);
                    setTheBlogLastUpdated(jsonBlog._ts);
                } else {
                    setTheBlog(data);
                    setTheBlogLastUpdated(previousState.lastUpdated);
                }

                determineBlogEditability(data);
                // if (theBlogAuthor) {
                //     // Workaround for an edit submission
                //     previousState.data = null;
                // }
            }
        } else {
            let pathNameSplit = location.pathname.split('/');
            let category = pathNameSplit[2];

            fetch(process.env.REACT_APP_BLOGS_API_URL + `?slug=${slug}&category=${category}`)
                .then(response => {
                    if (response.ok) {
                        response.text().then(value => {
                            let jsonBlog = JSON.parse(value);
                            setTheBlog(jsonBlog);
                            setTheBlogLastUpdated(jsonBlog._ts);
                            determineBlogEditability(jsonBlog);
                        })
                    } else {
                        navigate(window.location.pathname + '/..', { replace: true });
                    }
                })
                .catch(error => {
                    console.log(error)
                    navigate(window.location.pathname + '/..', { replace: true });
                });
        }

        // The 'determineBlogEditability' function makes the dependencies of useEffect Hook (at line 109) change on every render. 
        // Move it inside the useEffect callback.
        function determineBlogEditability(data) {
            if (userId && data) { // data is blog
                fetch(process.env.REACT_APP_CONTENT_AUTHOR_API_URL + `?id=${data.id}&user=${userId}`)
                    .then(response => {
                        if (response.ok) {
                            response.text().then(value => {
                                let blogOwnerFound = JSON.parse(value);
                                if (blogOwnerFound && blogOwnerFound[0] && blogOwnerFound[0].id) {
                                    if (blogOwnerFound[0].id === data.id) {
                                        setTheBlogAuthor(true);
                                    }
                                }
                            });
                        }
                    })
                    .catch(error => {
                        console.log(error);
                    });
            }
        }
    }, [location.state, navigate, theBlogLastUpdatedSwitch, slug, location.pathname, userId]); // useEffect occurs only if value changes
    ///////////////////////////////////////////////

    // this block of code handles editing content
    const [editMode, setEditMode] = useState(false);
    const toggleEditMode = () => setEditMode(!editMode);
    const [showPreview, setShowPreview] = useState(false);
    const handlePreviewShow = () => setShowPreview(true);
    const handlePreviewClose = () => setShowPreview(false);
    const [apiWaiting, setAPIWaiting] = useState(false);
    const [apiAlert, setAPIAlert] = useState(false);
    const [apiAlertMessage, setAPIAlertMessage] = useState(null);
    const [apiSuccess, setAPISuccess] = useState(false);
    const formContentEditRef = useRef();
    const handleEditSubmit = (event) => {
        event.preventDefault();

        if (formContentEditRef.current.value) {
            theBlog.formContent = formContentEditRef.current.value;
        }

        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(theBlog)
        };

        setAPIWaiting(true);

        theBlog._ts = Math.floor(new Date().getTime() / 1000); // javascript epoch has additional 3 digits at the end
        sessionStorage.setItem(theBlog.id, JSON.stringify(theBlog)); // just in case user refreshes the browser
        fetch(process.env.REACT_APP_CONTENT_EDIT_API_URL, requestOptions)
            .then(response => {
                if (response.ok) {
                    setAPISuccess(true);
                    setAPIAlert(false);

                    // refresh the page after a commit
                    setTheBlog(theBlog);
                    setEditMode(false);
                    setTheBlogLastUpdated(theBlog._ts);
                } else {
                    setAPIAlertMessage(response.status + ' - ' + response.statusText);
                    setAPIAlert(true);
                }
                setAPIWaiting(false);
            })
            .catch(error => {
                setAPIAlertMessage(error.toString());
                setAPIAlert(true);
                setAPIWaiting(false);
            });
    }
    ///////////////////////////////////////////////

    // this block of code handles blog deletion
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const handleDeleteClose = () => setShowDeleteModal(false);
    const handleDeleteShow = () => setShowDeleteModal(true);
    const handleDelete = (event) => {
        event?.preventDefault();

        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(theBlog)
        };

        fetch(process.env.REACT_APP_CONTENT_DELETE_API_URL, requestOptions)
            .then(response => {
                if (response.ok) {
                    console.log('Blog deleted successfully! Navigating back now...');
                    navigate(window.location.pathname + '/..', { replace: true });
                } else {
                    console.log(`It was not able to delete. It returned ${response.status}.`);
                }
            });
    }
    ///////////////////////////////////////////////

    const [imageLoadingStatus, setImageLoadingStatus] = useState(true);
    function imageOnLoad() {
        setImageLoadingStatus(false);
    }

    return (
        <>
            {
                theBlog &&
                <div className="blog-details-bg">
                    {
                        imageLoadingStatus &&
                        <>
                            <Placeholder
                                as="div"
                                animation="glow"
                                style={{ width: `${currWidth}`, alignContent: 'center' }}>
                                <Placeholder style={{ height: '350px' }} xs={12} />
                            </Placeholder>
                        </>
                    }
                    {
                        <img hidden={imageLoadingStatus} onLoad={imageOnLoad.bind(this)} alt="Visual art based on current width of the screen" src={`https://picsum.photos/${currWidth}/350`} />
                    }
                    <Container style={{ marginTop: "1rem", marginBottom: "1rem", minHeight: "60%" }}>
                        {
                            apiAlert &&
                            <Alert variant="danger" onClose={() => setAPIAlert(false)} dismissible style={{ borderRadius: '20px' }}>
                                <Alert.Heading>Oh snap! Something's not right...</Alert.Heading>
                                {
                                    apiAlert &&
                                    <>
                                        {
                                            !apiAlertMessage &&
                                            <>
                                                <p>
                                                    Cosmos API failed. Please try again later.
                                                </p>
                                            </>
                                        }
                                        {
                                            apiAlertMessage &&
                                            <>
                                                <p>
                                                    {apiAlertMessage}
                                                </p>
                                            </>
                                        }
                                    </>
                                }
                            </Alert>
                        }
                        {
                            apiSuccess &&
                            <Alert variant="success" onClose={() => setAPISuccess(false)} dismissible style={{ borderRadius: '20px' }}>
                                <Alert.Heading>Saved!</Alert.Heading>
                            </Alert>
                        }
                        <span style={{ cursor: "pointer", color: "#0d6efd" }} onClick={() => navigate(-1)}>
                            &laquo; Go back
                        </span>
                        <div className="text-center">
                            <h1>{theBlog.formTitle}</h1>
                            <div className='mb-3'>
                                {
                                    theBlog?.formTags?.map((tag, tagIdx) => (
                                        <Badge
                                            className="me-2"
                                            key={`tag-${tagIdx}`}
                                            pill
                                            bg="secondary">
                                            {tag.formTag}
                                        </Badge>
                                    ))
                                }
                            </div>
                            <Row>
                                {
                                    theBlogLastUpdated &&
                                    <small className="text-muted" >
                                        {
                                            theBlogLastUpdatedSwitch &&
                                            <span onClick={(event) => { event.preventDefault(); setTheBlogLastUpdatedSwitch(!theBlogLastUpdatedSwitch) }}>{getLastUpdatedByRelative(theBlogLastUpdated)}</span>
                                        }
                                        {
                                            !theBlogLastUpdatedSwitch &&
                                            <span onClick={(event) => { event.preventDefault(); setTheBlogLastUpdatedSwitch(!theBlogLastUpdatedSwitch) }}>{getLastUpdatedByAbsolute(theBlogLastUpdated)}</span>
                                        }
                                    </small>
                                }
                            </Row>
                        </div>
                        {
                            !editMode &&
                            <>
                                {
                                    theBlogAuthor &&
                                    <>
                                        <div className="text-center">
                                            <Button variant="link" onClick={toggleEditMode} style={{ marginRight: '1vw' }}>edit</Button>
                                            <Button variant="link" onClick={handleDeleteShow}>delete</Button>
                                        </div>
                                    </>
                                }
                                <div style={{ marginTop: "3rem" }} className="blog-details-text">
                                    <ReactMarkdownWithPlugins content={theBlog.formContent}></ReactMarkdownWithPlugins>
                                </div>
                            </>
                        }
                        {
                            editMode &&
                            <>
                                <div className="text-center">
                                    <Button variant="link" onClick={toggleEditMode}>cancel</Button>
                                </div>
                                <ContentEdit
                                    apiWaiting={apiWaiting}
                                    aboutContent={theBlog.formContent}
                                    formContentRef={formContentEditRef}
                                    handleShow={handlePreviewShow}
                                    handleSubmit={handleEditSubmit} />
                                {
                                    formContentEditRef && formContentEditRef.current &&
                                    <Preview
                                        preview={{ show: showPreview, content: formContentEditRef.current.value }}
                                        handleCallBack={handlePreviewClose} />
                                }
                            </>
                        }
                    </Container>
                    <div className="footer">
                        <div className="text-muted">
                            <div className='mb-2'>
                                <Link to="/" style={{ textDecoration: 'none', color: 'black' }}>Home</Link> | <Link to="/blogs" style={{ textDecoration: 'none', color: 'black' }}>Blogs</Link> | <a href="mailto:info@justinkim.dev" style={{ textDecoration: 'none', color: 'black' }}>Contact</a>
                            </div>
                            <div>&copy; 2023 JustinKim.dev</div>
                        </div>
                    </div>
                </div>
            }
            {
                !theBlog &&
                <div className="blog-details-loading-bg">
                    <Row xs={1} md={2} lg={2} className="g-2">
                        <Col>
                            <Link to=".." relative="path">
                                &laquo; Go back
                            </Link>
                        </Col>
                        <Col>
                            <div className="font-cherry-bomb">
                                Currently loading...
                            </div>
                        </Col>
                    </Row>

                    <div className="pl">
                        <div className="pl__outer-ring"></div>
                        <div className="pl__inner-ring"></div>
                        <div className="pl__track-cover"></div>
                        <div className="pl__ball">
                            <div className="pl__ball-texture"></div>
                            <div className="pl__ball-outer-shadow"></div>
                            <div className="pl__ball-inner-shadow"></div>
                            <div className="pl__ball-side-shadows"></div>
                        </div>
                    </div>
                </div>
            }
            {
                <Modal show={showDeleteModal} onHide={handleDeleteClose}>
                    <Modal.Header closeButton>
                        <Modal.Title>Are you sure?</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        Once deleted, it cannot be retrieved. Feel free to save the content elsewhere before you proceed.
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleDeleteClose}>
                            Close
                        </Button>
                        <Button variant="danger" onClick={handleDelete}>
                            Delete
                        </Button>
                    </Modal.Footer>
                </Modal>
            }
        </>
    );
}

export default BlogDetails;